// const formDataSchema ={
//     feilds: [{
//         id: 9,
//         name: 'role_name',
//         text: 'Role Name',
//         visible: true,
//         element: 'input',
//         required: true,
//         input_type: 'text',
//         placeholder: 'Enter',
//         icon: 'user',
//         rules: [
//             {
//                 test: (value) => {
//                     return (value !== null && value.length > 0);
//                     return true;
//                 },
//                 message: 'Please Enter Role Name'
//             }
//         ],
//         errors: [],
//         value: null,
//         valid: false,
//         state: '',
//         disable: false,
//         className: 'col-4'
//     },{
//             id: 10,
//             name: 'er_admission',
//             text: '(ER) Admission',
//             visible: true,
//             element: 'checkbox',
//             required: true,
//             input_type: 'checkbox',
//             placeholder: 'Enter',
//             icon: 'user',
//             rules: [
//                 {
//                     test: (value) => {
//                         //return (value !== null && value.length > 0);
//                         return true;
//                     },
//                     message: 'Please Check (ER) Admission'
//                 }
//             ],
//             errors: [],
//             value: null,
//             valid: false,
//             state: '',
//             disable: false,
//             className: 'col-3 pt-3'
//         },{
//             id: 11,
//             name: 'er_financial_counselling',
//             text: '(ER) Financial Counselling',
//             visible: true,
//             element: 'checkbox',
//             required: true,
//             input_type: 'checkbox',
//             placeholder: 'Enter',
//             icon: 'user',
//             rules: [
//                 {
//                     test: (value) => {
//                         //return (value !== null && value.length > 0);
//                         return true;
//                     },
//                     message: 'Please Check (ER) Financial Counselling'
//                 }
//             ],
//             errors: [],
//             value: null,
//             valid: false,
//             state: '',
//             disable: false,
//             className: 'col-3 pt-3 pr-0'
//         },{
//             id: 12,
//             name: 'er_billing_queries',
//             text: '(ER) Billing Queries',
//             visible: true,
//             element: 'checkbox',
//             required: true,
//             input_type: 'checkbox',
//             placeholder: 'Enter',
//             icon: 'user',
//             rules: [
//                 {
//                     test: (value) => {
//                         //return (value !== null && value.length > 0);
//                         return true;
//                     },
//                     message: 'Please Check (ER) Billing Queries'
//                 }
//             ],
//             errors: [],
//             value: null,
//             valid: false,
//             state: '',
//             disable: false,
//             className: 'col-3 pt-3'
//         },{
//             id: 12,
//             name: 'financial_counselling',
//             text: 'Financial Counselling',
//             visible: true,
//             element: 'checkbox',
//             required: true,
//             input_type: 'checkbox',
//             placeholder: 'Enter',
//             icon: 'user',
//             rules: [
//                 {
//                     test: (value) => {
//                         //return (value !== null && value.length > 0);
//                         return true;
//                     },
//                     message: 'Please Check Financial Counselling'
//                 }
//             ],
//             errors: [],
//             value: null,
//             valid: false,
//             state: '',
//             disable: false,
//             className: 'col-3 pt-3'
//         },{
//             id: 13,
//             name: 're_counselling',
//             text: 'Re-Counselling',
//             visible: true,
//             element: 'checkbox',
//             required: true,
//             input_type: 'checkbox',
//             placeholder: 'Enter',
//             icon: 'user',
//             rules: [
//                 {
//                     test: (value) => {
//                         //return (value !== null && value.length > 0);
//                         return true;
//                     },
//                     message: 'Please Check Re-Counselling'
//                 }
//             ],
//             errors: [],
//             value: null,
//             valid: false,
//             state: '',
//             disable: false,
//             className: 'col-3 pt-3'
//         },{
//             id: 13,
//             name: 'discharge_checkout',
//             text: 'Discharge & Checkout',
//             visible: true,
//             element: 'checkbox',
//             required: true,
//             input_type: 'checkbox',
//             placeholder: 'Enter',
//             icon: 'user',
//             rules: [
//                 {
//                     test: (value) => {
//                         //return (value !== null && value.length > 0);
//                         return true;
//                     },
//                     message: 'Please Check Discharge & Checkout'
//                 }
//             ],
//             errors: [],
//             value: null,
//             valid: false,
//             state: '',
//             disable: false,
//             className: 'col-3 pt-3'
//         },{
//             id: 14,
//             name: 'billing_queries',
//             text: 'Billing Queries',
//             visible: true,
//             element: 'checkbox',
//             required: true,
//             input_type: 'checkbox',
//             placeholder: 'Enter',
//             icon: 'user',
//             rules: [
//                 {
//                     test: (value) => {
//                         //return (value !== null && value.length > 0);
//                         return true;
//                     },
//                     message: 'Please Check Billing Queries'
//                 }
//             ],
//             errors: [],
//             value: null,
//             valid: false,
//             state: '',
//             disable: false,
//             className: 'col-3 pt-3'
//         },{
//             id: 15,
//             name: 'admission',
//             text: 'Admission',
//             visible: true,
//             element: 'checkbox',
//             required: true,
//             input_type: 'checkbox',
//             placeholder: 'Enter',
//             icon: 'user',
//             rules: [
//                 {
//                     test: (value) => {
//                         //return (value !== null && value.length > 0);
//                         return true;
//                     },
//                     message: 'Please Check Admission'
//                 }
//             ],
//             errors: [],
//             value: null,
//             valid: false,
//             state: '',
//             disable: false,
//             className: 'col-3 pt-3'
//         },{
//             id: 16,
//             name: 'payment',
//             text: 'Payment',
//             visible: true,
//             element: 'checkbox',
//             required: true,
//             input_type: 'checkbox',
//             placeholder: 'Enter',
//             icon: 'user',
//             rules: [
//                 {
//                     test: (value) => {
//                         //return (value !== null && value.length > 0);
//                         return true;
//                     },
//                     message: 'Please Check Payment'
//                 }
//             ],
//             errors: [],
//             value: null,
//             valid: false,
//             state: '',
//             disable: false,
//             className: 'col-3 pt-3'
//         },{
//             id: 17,
//             name: 'reimbursement',
//             text: 'Reimbursement',
//             visible: true,
//             element: 'checkbox',
//             required: true,
//             input_type: 'checkbox',
//             placeholder: 'Enter',
//             icon: 'user',
//             rules: [
//                 {
//                     test: (value) => {
//                         //return (value !== null && value.length > 0);
//                         return true;
//                     },
//                     message: 'Please Check Reimbursement'
//                 }
//             ],
//             errors: [],
//             value: null,
//             valid: false,
//             state: '',
//             disable: false,
//             className: 'col-3 pt-3'
//         },{
//             id: 18,
//             name: 'bill_tracking',
//             text: 'Bill Tracking',
//             visible: true,
//             element: 'checkbox',
//             required: true,
//             input_type: 'checkbox',
//             placeholder: 'Enter',
//             icon: 'user',
//             rules: [
//                 {
//                     test: (value) => {
//                         //return (value !== null && value.length > 0);
//                         return true;
//                     },
//                     message: 'Please Check Bill Tracking'
//                 }
//             ],
//             errors: [],
//             value: null,
//             valid: false,
//             state: '',
//             disable: false,
//             className: 'col-3 pt-3'
//         },{
//             id: 19,
//             name: 'manager_dashboard',
//             text: 'Manager Dashboard',
//             visible: true,
//             element: 'checkbox',
//             required: true,
//             input_type: 'checkbox',
//             placeholder: 'Enter',
//             icon: 'user',
//             rules: [
//                 {
//                     test: (value) => {
//                         //return (value !== null && value.length > 0);
//                         return true;
//                     },
//                     message: 'Please Check Manager Dashboard'
//                 }
//             ],
//             errors: [],
//             value: null,
//             valid: false,
//             state: '',
//             disable: false,
//             className: 'col-3 pt-3'
//         },{
//             id: 20,
//             name: 'add_new_user',
//             text: 'Add New User',
//             visible: true,
//             element: 'checkbox',
//             required: true,
//             input_type: 'checkbox',
//             placeholder: 'Enter',
//             icon: 'user',
//             rules: [
//                 {
//                     test: (value) => {
//                         //return (value !== null && value.length > 0);
//                         return true;
//                     },
//                     message: 'Please Check Add New User'
//                 }
//             ],
//             errors: [],
//             value: null,
//             valid: false,
//             state: '',
//             disable: false,
//             className: 'col-3 pt-3'
//         },{
//             id: 21,
//             name: 'privilege_creation',
//             text: 'Privilege Creation',
//             visible: true,
//             element: 'checkbox',
//             required: true,
//             input_type: 'checkbox',
//             placeholder: 'Enter',
//             icon: 'user',
//             rules: [
//                 {
//                     test: (value) => {
//                         //return (value !== null && value.length > 0);
//                         return true;
//                     },
//                     message: 'Please Check Privilege Creation'
//                 }
//             ],
//             errors: [],
//             value: null,
//             valid: false,
//             state: '',
//             disable: false,
//             className: 'col-3 pt-3'
//         },{
//             id: 22,
//             name: 'fc_previlage_mapping',
//             text: 'FC - Previlage Mapping',
//             visible: true,
//             element: 'checkbox',
//             required: true,
//             input_type: 'checkbox',
//             placeholder: 'Enter',
//             icon: 'user',
//             rules: [
//                 {
//                     test: (value) => {
//                         //return (value !== null && value.length > 0);
//                         return true;
//                     },
//                     message: 'Please Check FC - Previlage Mapping'
//                 }
//             ],
//             errors: [],
//             value: null,
//             valid: false,
//             state: '',
//             disable: false,
//             className: 'col-3 pt-3'
//         },{
//             id: 23,
//             name: 'tat_reports',
//             text: 'TAT Reports',
//             visible: true,
//             element: 'checkbox',
//             required: true,
//             input_type: 'checkbox',
//             placeholder: 'Enter',
//             icon: 'user',
//             rules: [
//                 {
//                     test: (value) => {
//                         //return (value !== null && value.length > 0);
//                         return true;
//                     },
//                     message: 'Please Check TAT Reports'
//                 }
//             ],
//             errors: [],
//             value: null,
//             valid: false,
//             state: '',
//             disable: false,
//             className: 'col-3 pt-3'
//         }
//     ]
// }



const formDataSchema = {
    feilds: [{
        id: 9,
        name: 'role_name',
        text: 'Role Name',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'text',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Enter Role Name'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 21,
        name: 'rolePageTable',
        text: 'Add Role',
        visible: true,
        required: false,
        element: 'table',
        input_type: 'button',
        disable: false,
        colums: [
            {
                id: 1,
                name: 'Page Name'
            }, {
                id: 2,
                name: 'View'
            }, {
                id: 3,
                name: 'Edit'
            }, {
                id: 6,
                name: 'Add'
            }, {
                id: 4,
                name: 'Delete'
            }, {
                id: 5,
                name: 'Download'
            }
        ]
    }
    ]
}

export { formDataSchema };